const noOp = () => ({ type: "NO_OP" });

export const apiPayloadCreator = ({
  url = "/",
  method = "GET",
  onSuccess = noOp,
  onFailure = noOp,
  onSuccessWithoutDispatch = noOp,
  onFailureWithoutDispatch = noOp,
  label = "",
  data = "",
  params = "",
  headers = {},
}) => ({
  url,
  method,
  onSuccess,
  onFailure,
  onSuccessWithoutDispatch,
  onFailureWithoutDispatch,
  label,
  data,
  params,
  headers,
});